import {
  Component,
  Input,
  OnInit,
  Output,
  EventEmitter,
  OnChanges,
  SimpleChanges
} from '@angular/core';
import { imgUrl } from '@shared/globals/app-constants';
import { IUser } from '@shared/models/login.model';
import { ToastCustomService } from '@shared/services/toast-custom.service';
import { UserService } from '@shared/services/user.service';
import { IChatConversation, IChatMember } from '../../models/chat.model';

@Component({
  selector: 'app-conversation',
  templateUrl: './conversation.component.html',
  styleUrls: ['./conversation.component.scss']
})
export class ConversationComponent implements OnInit, OnChanges {
  @Input()
  public conversation: IChatConversation;
  @Input()
  public memberSelected: IChatMember;
  @Output()
  private emitMessage: EventEmitter<{
    id: number;
    message: string;
    roomName: string;
  }> = new EventEmitter<{ id: number; message: string; roomName: string }>();
  public user: IUser;
  public message: string;
  public environmentUrl = imgUrl;
  constructor(
    private ts: ToastCustomService,
    private userService: UserService
  ) {
    this.user = this.userService.userInfo;
  }

  ngOnInit() {
    this.scrollBottom();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.conversation && changes.conversation.currentValue) {
      this.scrollBottom();
    }
    if (changes.memberSelected && changes.memberSelected.currentValue) {
      this.memberSelected.photo =
        this.memberSelected.photo && this.memberSelected.photo.includes('http')
          ? this.memberSelected.photo
          : imgUrl + this.memberSelected.photo;
    }
  }

  public sendMessage(): void {
    if (
      this.message !== '' &&
      this.message !== null &&
      this.message !== undefined
    ) {
      const userId = this.getIdContact();
      if (userId) {
        this.emitMessage.emit({
          id: userId,
          message: this.message,
          roomName: this.conversation.roomName
        });
        this.conversation.messages.push({
          created_at: new Date().toString(),
          destinationUser: this.getUserFromConversation(userId),
          message: this.message,
          originUser: this.user,
          roomName: `private-chat-message:${userId}-${this.user.id}`
        });
        this.scrollBottom();
        this.message = null;
      } else {
        this.ts.show(
          'warning',
          'Message could not be sent',
          'Something went wrong, please report to IT team'
        );
      }
    }
  }

  private getIdContact(): number {
    let id = null;
    const array = this.conversation.roomName.split(':');
    const ids = array[1] ? array[1].split('-') : [];
    if (ids.length > 0) {
      const result = ids.filter(id => parseInt(id, 10) !== this.user.id);
      id = result[0] ? parseInt(result[0], 10) : null;
    }
    return id;
  }

  private getUserFromConversation(id: number): IUser {
    let user: IUser = null;
    this.conversation.messages.forEach(msg => {
      if (msg.destinationUser ? msg.destinationUser.id === id : false) {
        user = msg.destinationUser;
      }
      if (msg.originUser ? msg.originUser.id === id : false) {
        user = msg.originUser;
      }
    });
    return user;
  }

  public scrollBottom() {
    setTimeout(() => {
      const objDiv = document.getElementById('chat');
      if (objDiv) {
        objDiv.scrollTop = objDiv.scrollHeight;
      }
    }, 100);
  }
}
